import { observable, action, makeObservable } from 'mobx';
// import { user, meeting } from './index';
interface handupSettigData {
  handUpStaticWebp?: string; // 举手静态图
  handUpAnimWebp?: string; //举手动态图
  handUpAnimWebpDuration?: number; //  举手动态图动画时长，毫秒
}
class Reaction {
  constructor() {
    makeObservable(this);
  }

  @observable reactionVisible = false;

  @observable cancelHanupVisible = false;

  @observable staticEmoList = [];
  @observable handUp = false;
  @observable handupSetting: handupSettigData = {
    handUpStaticWebp: '',
    handUpAnimWebp: '',
    handUpAnimWebpDuration: 0,
  };

  @observable showHandup = false;

  @action setShowhandup = (value: boolean) => {
    this.showHandup = value;
  };

  @action setCancelHanupVisible = (value: boolean) => {
    this.cancelHanupVisible = value;
  };

  @action setHandupSetting = (value: handupSettigData) => {
    this.handupSetting = value;
  };
  @action setReactionVisible = (value: boolean) => {
    this.reactionVisible = value;
  };

  @action setHanUp = (value: boolean) => {
    this.handUp = value;
  };

  @action setStaticEmoList = (data: any) => {
    this.staticEmoList = data;
  };
}

export default Reaction;
